import {useTranslation} from 'react-i18next';
import {List, Button} from '@tickchak/react-share/app';
import ModeBtn from '../../../component/modeBtn/ModeBtn';
import useRouteInfo from '../hooks/useRouteInfo';
import {SupportVideosHeaderProps} from './SupportVideos.type';
import * as css from './supportVideos.css';
import MasterPermission from '../../../pages/components/rolePermission/MasterPermission';
import Plus from '../../../assets/icons/Plus';
import Survey from '../../../assets/icons/Survey';

export const getPageTranslation = (t: (key: string) => string, pageTitle: string): string => 
    pageTitle.split('_').map(item => t(item)).join(' > ');

function SupportVideosHeader({isShowingAll, searchValue, onRefresh, onOpenForm, onOpenRating, pageType}: SupportVideosHeaderProps) {
    const {t} = useTranslation('layout');
    const routeInfo = useRouteInfo();
    const currentPageType = pageType || routeInfo.pageType;

    return (
        <>
            <List.Header 
                fixed={true}
                title={t('supportTitle')}
                subtitle={`${t('inArea')} ${getPageTranslation(t, currentPageType)}`}
            />
            <MasterPermission>
                    <css.headerActionsContainer>
                        <Button 
                            variant="brand"
                            size="category"
                            onClick={onOpenRating}
                            iconEnd={<Survey />}
                        />
                        <Button
                            variant="brand"
                            size="category"
                            onClick={() => onOpenForm(null, currentPageType)}
                            iconStart={<Plus />}
                        >
                            {t('newGuide')}
                        </Button>
                    </css.headerActionsContainer>
                </MasterPermission>
            <css.showAll>
                <ModeBtn 
                    click={() => onRefresh(searchValue, !isShowingAll)}
                    status={isShowingAll} 
                    text={t('showAll')} 
                    dataCyName={'showAll'} 
                    requestStatus={undefined}
                    dataTitle={undefined} 
                    className={undefined} 
                />
            </css.showAll>
            <List.Search 
                placeholder={t('searchVideos')}
                onSearch={(value: string) => onRefresh(value, isShowingAll)}
                searchDelayMs={300}
            />
        </>
    );
}

export default SupportVideosHeader;
